import React, { useEffect } from "react";
import "./Popover.scss";

const PopoverItem = ({ label, className, onClick }) => {
	return (
		<div className={`popover-item ${className ? className : ""}`} onClick={onClick}>
			<div className="text text-body--4">{label}</div>
		</div>
	);
};

export default PopoverItem;
